import React from "react";
import { IConsentLetters, ISurgicalData } from "../../exports/interfaces";
import { marked } from "marked";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { Fade } from "react-awesome-reveal";
import { useLoader } from "../../context/LoaderContext";
import { useUserDataContext } from "../../context/UserDataContext";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";

type SurgicalName =
  | "Rhinoplasty"
  | "Lower_Blepharoplasty"
  | "Upper_Blepharoplasty"
  | "Face_Lift"
  | "ForeHead_Lift"
  | "Mentoplasty"
  | "Otoplasty"
  | "Scar_Revision"
  | "Skin_Cancer"
  | "Skin_Peels"
  | "Botulinum_Toxin"
  | "Fat_Grafting";

const SurgicalDomainsDescription = ({
  descriptionData,
  consentLetters,
  surgicalName,
}: {
  descriptionData: ISurgicalData[];
  consentLetters?: IConsentLetters[];
  surgicalName?: string;
}) => {
  const { loading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const isValidSurgicalName = (name: string): name is SurgicalName => {
    return [
      "Rhinoplasty",
      "Lower_Blepharoplasty",
      "Upper_Blepharoplasty",
      "Face_Lift",
      "ForeHead_Lift",
      "Mentoplasty",
      "Otoplasty",
      "Scar_Revision",
      "Skin_Cancer",
      "Skin_Peels",
      "Botulinum_Toxin",
      "Fat_Grafting",
    ].includes(name);
  };
  let dynamicConsentUrl: string | undefined = undefined;
  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };

  if (
    consentLetters &&
    consentLetters.length > 0 &&
    surgicalName &&
    isValidSurgicalName(surgicalName)
  ) {
    dynamicConsentUrl =
      consentLetters[0].attributes[surgicalName]?.data?.attributes?.url;
  }
  const { userData } = useUserDataContext();
  return (
    <>
      <section
        // className="about-page"
        style={{
          paddingBottom: "90px",
        }}
      >
        <div className="container">
          <div className="row">
            {descriptionData.map((data, index) => {
              const isEven = index % 2 === 0;

              return (
                <section
                  // className="about-page"
                  key={index}
                  style={{
                    padding: "90px 0 0px",
                  }}
                >
                  <div className="container">
                    <div className="row">
                      <div className={`col-xl-6 ${isEven ? "" : "order-xl-2"}`}>
                        <div
                          className="about-page__left wow slideInLeft"
                          data-wow-delay="100ms"
                          data-wow-duration="2500ms"
                          style={{
                            marginRight:
                              !mobile && !tab
                                ? isEven
                                  ? "40px"
                                  : "unset"
                                : "",
                            marginLeft:
                              !mobile && !tab
                                ? isEven
                                  ? "unset"
                                  : "40px"
                                : "",
                          }}
                        >
                          {!loading && (
                            <Fade
                              cascade
                              damping={0.2}
                              direction={isEven ? "left" : "right"}
                              triggerOnce={true}
                            >
                              <div className="about-page__img">
                                <img
                                  src={`${process.env.REACT_APP_strapiUrl}${data?.attributes?.Image?.data?.attributes?.url}`}
                                  alt="about-image"
                                  style={{
                                    objectFit: "cover",
                                    height: "489px",
                                  }}
                                />
                              </div>
                            </Fade>
                          )}
                        </div>
                      </div>

                      <div className={`col-xl-6 ${isEven ? "" : "order-xl-1"}`}>
                        <div
                          className="about-page__right"
                          style={{
                            marginRight:
                              !mobile && !tab
                                ? isEven
                                  ? "unset"
                                  : "40px"
                                : "",
                            marginLeft:
                              !mobile && !tab
                                ? isEven
                                  ? "40px"
                                  : "unset"
                                : "",
                          }}
                        >
                          <div className="section-title text-left">
                            <h2 className="section-title__title">
                              {data?.attributes?.Title}
                            </h2>
                          </div>
                          <p
                            className="about-page__text"
                            style={{ textAlign: "justify" }}
                            dangerouslySetInnerHTML={{
                              __html: marked(
                                data?.attributes?.Description || ""
                              ) as string,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              );
            })}
            {surgicalName && (dynamicConsentUrl && userData ? (
              <div
                className="become-volunteer__btn-box"
                style={{ marginTop: "40px", paddingLeft: "15px" }}
              >
                <a
                  href={`${process.env.REACT_APP_strapiUrl}${dynamicConsentUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="thm-btn become-volunteer__btn"
                >
                  Download Consent Form
                </a>
              </div>
            ) : !userData ? (
              <div
                className="become-volunteer__btn-box"
                style={{ marginTop: "40px" }}
              >
                <p>Become a Member to Download Consent Form</p>
                <Link
                  to="/become-a-member"
                  // className="donate-btn main-header-two__btn"
                  className="thm-btn main-header-two__btn custom-donate-btn"
                  style={{ paddingLeft: "5px" }}
                  onClick={() => linkClicker("become-a-member")}
                >
                  {" "}
                  <i className="icon-user-plus"></i>
                  Become a Member
                </Link>
              </div>
            ) : (
              <div
                className="become-volunteer__btn-box"
                style={{ marginTop: "40px" }}
              >
                <p>No Consent Form Available</p>
              </div>
            )
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SurgicalDomainsDescription;
